// The "walking on water" photo from the home page hero is reused as texture on collection banners, the logo band
// and the story / questions page backdrop. Everything reads the first hero slide of the home page, so changing the
// home hero image updates all of them automatically. Falls back to each spot's own image if anything fails.
(function () {
  var KEY = 'mirrorless-home-hero-v1';
  var TTL = 10 * 60 * 1000;
  var jobs = [];

  function addJob(pic, y, hidden) {
    var img = pic && pic.querySelector('img');
    if (!pic || !img) return;
    jobs.push({ pic: pic, img: img, y: y, shown: false });
    if (hidden) {
      img.style.transition = 'opacity 0.4s ease';
      img.style.opacity = '0';
    }
  }

  // Collection banner: a different slice of the water for each collection (all below the figure in the photo)
  var banner = document.querySelector('collection-banner');
  if (banner) {
    var handle = ((location.pathname.match(/\/collections\/([^\/?#]+)/) || [])[1]) || '';
    var hash = 0;
    for (var i = 0; i < handle.length; i++) hash = (hash * 31 + handle.charCodeAt(i)) >>> 0;
    var slices = [92, 95, 98, 100];
    addJob(banner.querySelector('picture'), slices[hash % slices.length], true);
  }

  // Logo band on the story page
  document.querySelectorAll('.logo-band__water').forEach(function (pic) {
    addJob(pic, 100, false);
  });

  // Textured backdrop behind the story and questions pages
  var cls = document.body.classList;
  if (cls.contains('page-contact') || cls.contains('page-questions')) {
    var wrap = document.createElement('div');
    wrap.className = 'water-backdrop';
    wrap.setAttribute('aria-hidden', 'true');
    var bp = document.createElement('picture');
    var bi = document.createElement('img');
    bi.alt = '';
    bp.appendChild(bi);
    wrap.appendChild(bp);
    document.body.insertBefore(wrap, document.body.firstChild);
    addJob(bp, 100, true);
  }

  if (!jobs.length) return;

  function show(job) {
    if (job.shown) return;
    job.shown = true;
    job.img.style.objectPosition = '50% ' + job.y + '%';
    job.img.style.opacity = '1';
  }
  function showAll() { jobs.forEach(show); }
  setTimeout(showAll, 1800);

  function apply(hero) {
    jobs.forEach(function (job) {
      job.pic.querySelectorAll('source').forEach(function (s) { s.remove(); });
      (hero.sources || []).forEach(function (s) {
        var el = document.createElement('source');
        if (s.media) el.media = s.media;
        el.srcset = s.srcset;
        job.pic.insertBefore(el, job.img);
      });
      job.img.removeAttribute('srcset');
      job.img.sizes = '100vw';
      job.img.onload = function () { show(job); };
      job.img.srcset = hero.srcset || '';
      job.img.src = hero.src;
      if (job.img.complete && job.img.naturalWidth) show(job);
    });
  }

  function fromHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var heroPic = doc.querySelector('.shopify-section--slideshow picture');
    var heroImg = heroPic && heroPic.querySelector('img');
    if (!heroImg) return null;
    return {
      src: heroImg.getAttribute('src'),
      srcset: heroImg.getAttribute('srcset'),
      sources: Array.prototype.map.call(heroPic.querySelectorAll('source'), function (s) {
        return { media: s.getAttribute('media'), srcset: s.getAttribute('srcset') };
      })
    };
  }

  var cached = null;
  try {
    cached = JSON.parse(sessionStorage.getItem(KEY) || 'null');
  } catch (e) {}

  if (cached && Date.now() - cached.t < TTL && cached.hero) {
    apply(cached.hero);
    return;
  }

  fetch('/', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
    .then(function (html) {
      var hero = fromHtml(html);
      if (!hero) return showAll();
      try {
        sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), hero: hero }));
      } catch (e) {}
      apply(hero);
    })
    .catch(showAll);
})();